"use client";
import React from "react";
import Container from "@sendsprint/ui-react/components/container";
import Typography from "@sendsprint/ui-react/components/typography";
import Box from "@sendsprint/ui-react/components/box";
import cs from "classnames";
import Button from "@sendsprint/ui-react/components/button";
import Link from "next/link";
import { Path } from "@/navigations/routes";
import useHeader from "@/layouts/general/hooks/useHeader";
import ArrowIcon from "@/assets/svgs/faqs/arrow.svg";
import UserIcon from "@/assets/svgs/faqs/user.svg";
import MoneyIcon from "@/assets/svgs/faqs/money.svg";
import KeyIcon from "@/assets/svgs/faqs/key.svg";

const Topics = () => {
  const { handleIntercomShow } = useHeader();

  return (
    <Box as="section" className={cs("ss:mb-6")}>
      <Container>
        <Typography
          as="h6"
          variant="h6"
          desktopVariant="h6"
          xlDesktopVariant="h6"
          className="ss:max-w-[470px] ss:mx-auto ss:mb-3 ss:font-semibold"
        >
          Explore all topics
        </Typography>
        <Box className="ss:max-w-[470px] ss:mx-auto ss:flex ss:justify-between ss:flex-col ss:md:flex-row ss:gap-6 ss:mb-6">
          <Link href={Path.AboutFaq}>
            <Box className="ss:rounded-[16px] ss:w-[224px] ss:h-[215.97px] ss:bg-[#E9F9EF] ss:text-center ss:p-5">
              <ArrowIcon aria-hidden className="ss:w-10 ss:h-10 ss:m-auto" />
              <Typography
                as="h6"
                variant="h6"
                desktopVariant="h6"
                xlDesktopVariant="h6"
                className="ss:font-semibold ss:my-3"
              >
                About Sendsprint
              </Typography>
              <Typography
                as="p"
                variant="paragraphRegular"
                className="ss:text-[14px]"
              >
                Everything You Need to Know About Us.
              </Typography>
            </Box>
          </Link>
          <Link href={Path.ManageAccountFaq}>
            <Box className="ss:rounded-[16px] ss:w-[224px] ss:h-[215.97px] ss:bg-[#FEF5E7] ss:text-center ss:p-5">
              <UserIcon aria-hidden className="ss:w-10 ss:h-10 ss:m-auto" />
              <Typography
                as="h6"
                variant="h6"
                desktopVariant="h6"
                xlDesktopVariant="h6"
                className="ss:font-semibold ss:my-3"
              >
                Managing Account
              </Typography>
              <Typography
                as="p"
                variant="paragraphRegular"
                className="ss:text-[14px]"
              >
                Signup, verification, updates, security, and login issues.
              </Typography>
            </Box>
          </Link>
        </Box>
        <Box className="ss:max-w-[470px] ss:mx-auto ss:flex ss:justify-between ss:flex-col ss:md:flex-row ss:gap-4">
          <Link href={Path.SendMoneyFaq}>
            <Box className="ss:rounded-[16px] ss:w-[224px] ss:h-[215.97px] ss:bg-[#FFEFEE] ss:text-center ss:p-5">
              <MoneyIcon aria-hidden className="ss:w-10 ss:h-10 ss:m-auto" />
              <Typography
                as="h6"
                variant="h6"
                desktopVariant="h6"
                xlDesktopVariant="h6"
                className="ss:font-semibold ss:my-3"
              >
                Sending Money
              </Typography>
              <Typography
                as="p"
                variant="paragraphRegular"
                className="ss:text-[14px]"
              >
                Essential guide to sending money with Sendsprint.
              </Typography>
            </Box>
          </Link>
          <Link href={Path.ReferralFaq}>
            <Box className="ss:rounded-[16px] ss:w-[224px] ss:h-[215.97px] ss:bg-[#F8F9F7] ss:text-center ss:p-5">
              <KeyIcon aria-hidden className="ss:w-10 ss:h-10 ss:m-auto" />
              <Typography
                as="h6"
                variant="h6"
                desktopVariant="h6"
                xlDesktopVariant="h6"
                className="ss:font-semibold ss:my-3"
              >
                Referrals
              </Typography>
              <Typography
                as="p"
                variant="paragraphRegular"
                className="ss:text-[14px]"
              >
                Complete details about our referral program.
              </Typography>
            </Box>
          </Link>
        </Box>

        <Box className="ss:my-8 ss:max-w-[300px] ss:mx-auto ss:flex ss:flex-col ss:md:flex-row ss:justify-center ss:items-center ss:gap-4">
          <Typography
            as="p"
            variant="paragraphRegular"
            className="ss:text-[18px] ss:font-semibold"
          >
            Still need help?
          </Typography>
          <Box>
            <Button
              onClick={handleIntercomShow}
              variant="secondary"
              label="Contact us"
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Topics;
